<template>
    <div class="details" :style="{ minHeight: height + 'px' }">
          <a-button @click="goBack"  type="primary">返回</a-button>
          <div class="titile">{{ data.contentTitle }}</div>
          <div class="content" v-html="data.content"></div>    
    </div>    
</template>
<script>
export default {
    data(){
        return{
           height:'',
           data:'',
        }
    },
    watch: {
        $route(){
            this.getDetail(this.$route.query.id)
        },
    },
    created(){
        this.$parent.current = '8';
        this.height = document.body.clientHeight - 85;
        let id = this.$route.query.id;
        this.getDetail(id);
    },
    methods:{
        goBack(){
            if(this.$route.query.activeIndex){
                this.$router.push({
                    path:'/news',
                    query:{
                        activeIndex:this.$route.query.activeIndex
                    }

                })
            }else{
                this.$router.go(-1) 
            }
        },
        getDetail(id){
             this.$https.get('/portal/content/getContentById',{params:{id:id}}).then(res=>{
                  this.data = res;
             })
        }
    }
}
</script>

<style lang="less" scoped>
.details{
    width: 1300px;
    margin:0 auto;
    .titile{
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        margin-top:10px;
        margin-bottom: 20px;
    }
    .content{
        overflow: hidden;
    }

}
</style>